module.exports = __webpack_public_path__ + "static/media/paulina.159cd320.png";